var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatStar = function SvgChatStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#chat-star_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 7.875,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 6.75,
    fill: "url(#chat-star_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.27 10.154a.01.01 0 0 1-.009.009c-2.379.147-4.282 2.039-4.43 4.403a.01.01 0 0 1-.009.01.01.01 0 0 1-.009-.01c-.148-2.364-2.05-4.256-4.43-4.403a.01.01 0 0 1 0-.018c2.38-.147 4.282-2.039 4.43-4.404a.01.01 0 0 1 .01-.009.01.01 0 0 1 .008.01c.148 2.364 2.051 4.256 4.43 4.403a.01.01 0 0 1 .009.009m1.792-3.735a.01.01 0 0 1-.005.005 2.65 2.65 0 0 0-2.486 2.472.01.01 0 0 1-.005.004.01.01 0 0 1-.005-.004 2.65 2.65 0 0 0-2.486-2.472.01.01 0 0 1-.005-.005q0-.005.005-.005a2.65 2.65 0 0 0 2.486-2.472q0-.004.005-.005.006 0 .005.005a2.65 2.65 0 0 0 2.487 2.472q.004 0 .004.005"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chat-star_svg__b",
    x1: 21.549,
    x2: 7.659,
    y1: -0.873,
    y2: 15.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01FABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0164FD"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "chat-star_svg__a",
    width: 26,
    height: 26,
    x: -1,
    y: -2,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_739_21194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_739_21194",
    result: "shape"
  })))));
};
export default SvgChatStar;